import { Component, Input } from "@angular/core";
import { IGeofence } from "@app/interfaces/IGeofences";
import './delivery-profile-view.component.scss';

@Component({
    selector: "delivery-profile-view",
    template: require("./delivery-profile-view.component.html")
})
export class DeliveryProfileViewComponent {
    @Input()  geofence: IGeofence;
}
